<style>

</style>
<template>
  <div v-loading='loading'>
    <el-card class="apidefined-header" v-if="showMain">
      <div slot="header">
        <el-button type="primary" @click="backtohome">返回</el-button>
        <div style="float:right;">接口组:{{detailData.GroupNO}}.{{detailData.GroupName}}</div>
      </div>
      <div class="apidefined-body">
        <el-tabs v-model="tab">
          <el-tab-pane label="标准查询" name="first">
            <show-table
              ref="StdQuery"
              @editItem = 'editServer'
              @delItem = 'delServer'
              :queryobj = 'queryObj1'
              :queryparam = 'queryParam'
              :showopertbtn = 'showType'>
              <el-button type="primary" icon="plus" size="small" @click="addNewServer('StdQuery')" slot="add" >新增服务</el-button>
            </show-table>
          </el-tab-pane>
          <el-tab-pane label="数据对象" name="second">
            <show-table
              ref="DataObject"
              @editItem = 'editServer'
              @delItem = 'delServer'
              :queryobj = 'queryObj2'
              :queryparam = 'queryParam'
              :showopertbtn = 'showType'>
              <el-button type="primary" icon="plus" size="small" @click="addNewServer('DataObject')" slot="add">新增服务</el-button>
            </show-table>
          </el-tab-pane>
          <el-tab-pane label="业务逻辑" name="third">
            <show-table
              ref="Business"
              @editItem = 'editServer'
              @delItem = 'delServer'
              :queryobj = 'queryObj3'
              :queryparam = 'queryParam'
              :showopertbtn = 'showType'>
              <el-button type="primary" icon="plus" size="small" @click="addNewServer('Business')" slot="add">新增服务</el-button>
            </show-table>
          </el-tab-pane>
        </el-tabs>
      </div>
    </el-card>
    <apiserver-definedadd
      @goback="goBack"
      :detaildata = 'detailData'
      :apitype="APItype"
      v-else
      :opertion="opertionType"></apiserver-definedadd>
  </div>
</template>
<script>
  import  util from '../../../util.js'
  import apiServerDefinedAdd from './apiServerDefinedAdd.vue'
  import {DataObjectUpdate, bizQueryBatchExecute} from '../../../vuex/actions'
  import {sessionUser} from '../../../vuex/getters'
	export default {
    props: ['detaildata'],
    vuex: {
      getters: {
        sessionUser
      },
      actions: {
        DataObjectUpdate,
        bizQueryBatchExecute
      }
    },
	  data () {
	    return {
        detailData: this.detaildata,
        loading: false,
        APItype: '',
	      tab: 'first',
        showMain:true,
        opertionType: '',
        queryObj1: {
          queryName: 'GetOAuthGroup',
          ServerID: '',
          GroupNO:this.detaildata.GroupNO,
          ServerTypeID: 1,
          displayLabel: '服务ID/名称',
        },
        queryObj2: {
          queryName: 'GetOAuthGroup',
          ServerID: '',
          GroupNO:this.detaildata.GroupNO,
          ServerTypeID: 2,
          displayLabel: '服务ID/名称',
        },
        queryObj3: {
          queryName: 'GetOAuthGroup',
          ServerID: '',
          GroupNO:this.detaildata.GroupNO,
          ServerTypeID: 3,
          displayLabel: '服务ID/名称',
        },
        //table中可以操作的按钮显示与否
        showType: {
          edit: true,
          del: true,
          defined: false,
        },
        queryParam: 'ServerID',
      }
    },
    components:{
      "apiserver-definedadd":apiServerDefinedAdd,
    },
    methods: {
      addNewServer (type) {
        this.opertionType = 'add'
        this.APItype = type
        this.showMain = false;
        this.$emit('addnavigate',{type:type,showflag:true});
      },
      goBack(data){
        this.showMain = true
        this.DataObjectUpdate({
          objectName: 'OAuthGroup',
          GroupNO: this.detailData.GroupNO,
          PaperNO: '',
        }, (res) => {
          if(res.isValid && res.data.isValid){
            this.detailData = res.data.dataList.dataList_0[0]
          }
        })
        this.$emit('addnavigate',{type:'',showflag:false});
      },
      backtohome () {
        this.$emit('goback')
      },
      editServer (data) {
        this.opertionType = 'detail'
        this.detailData = data
        this.$emit('addnavigate',{type:this.detailData.ServerType,showflag:true});
        this.showMain = false
      },
      delServer (data) {console.log(data)
        let params = {
          dataList_0: [{
            //请求必填参数
            BusinessID: 'OAuthGroupModify',
            OperName: this.sessionUser.userName,
            Operator: this.sessionUser.userId,
            LastUpdateTime: this.detailData.LastUpdateTime,
            Old_LastUpdateTime: this.detailData.LastUpdateTime,
            ModuleID: this.$route.params.moduleID || '299303',
            ActionNO: 'OAuthGroupModify',
            PaperNO: '',
            //输入参数
            GroupNO:this.detailData.GroupNO,
            GroupName:this.detailData.GroupName,
            Memo:this.detailData.Memo,
          }],
          dataList_1: [{
            InterfaceName: data.InterfaceName,
            AServerName: data.AServerName,
            Summary: data.Summary,
            ServerTypeID: data.ServerTypeID,
            ServerType: data.ServerType,
            ServerID: data.ServerID,
            Tag1: data.Tag1,
            UpdateFlag: 'D'
          }]
        }
        this.$confirm(`确认删除当前接口服务【${data.InterfaceName}】定义吗？`, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.loading = true
          this.bizQueryBatchExecute(params, (res) => {
            this.loading = false
            if(res.isValid && res.data.isValid){
              this.$refs[params.dataList_1[0].ServerType].searchData()
              util.success(this, `接口${params.dataList_1[0].InterfaceName}删除成功`)
            }
          })
        }).catch(() => {
          console.log('cancel')
        })
      }
    }
  }
</script>




// WEBPACK FOOTER //
// apiServerDefined.vue?42c212a0